import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import "./plugins/global-components";
import "./plugins/global-validations";
import vuetify from "./plugins/vuetify";
import HTTP from "@/http-common";
import MapMixin from "@/mixins/store.mixin";
import "./plugins/global-filters";
import LogRocket from "logrocket";
import { VueLd } from "vue-ld";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

Vue.use(VueLd, {
  clientSideId: process.env.LAUNCHDARKLY,
  user: {
    anonymous: true,
  },
  readyBeforeIdentify: false,
});

if (process.env.ENVIRONMENT !== "development") LogRocket.init("uotsmx/optus");
Sentry.init({
  Vue,
  dsn: "https://40267eb7f2b1450293015ad7af8adacc@o166430.ingest.sentry.io/6113577",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "connect.2sg.com.au", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: .1,
});

Vue.config.productionTip = false;

Vue.mixin(MapMixin);
Vue.prototype.$HTTP = HTTP;

new Vue({
  store,
  router,
  vuetify,
  DatePicker,
  render: h => h(App)
}).$mount("#app");
